import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

/**
 * Komponent SVG dla obszaru B - sedan widok górny (center)
 */
export const AreaB_Sedan_Top: React.FC<AreaSVGProps> = ({
  fill = '#73C69B',
  stroke = '#73C69B',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="161"
      height="237"
      viewBox="0 0 161 237"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_b_sedan_top"
          x="0"
          y="0"
          width="161"
          height="237"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>

      <g filter="url(#filter_area_b_sedan_top)">
        <path
          d="M81.0078 1C100.867 1 137.815 3.28879 159.91 6.27832C156.985 35.7523 154.17 100.741 153.428 132.382C153.344 135.947 153.118 141.922 152.829 149.519C152.068 169.566 150.881 200.854 150.786 228.625C137.103 232.713 114.422 236 81.0088 236C47.1237 236 24.2353 232.752 10.3799 228.664C10.34 200.586 9.14885 168.861 8.39551 148.83V148.829C8.12203 141.558 7.90676 135.835 7.8252 132.381C7.07854 100.725 4.06523 35.7605 1.09082 6.28516C23.4262 3.2921 60.9356 1.00002 81.0078 1Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
